import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'เมนูหลัก',
    isTitle: true,
  },
  {
    label: 'แผงบริหาร',
    icon: 'home',
    link: '/dashboard',
  },
  {
    label: 'จัดการข้อมูลหน่วยงาน',
    isTitle: true,
  },
  {
    label: 'ส่วนงาน',
    icon: 'server',
    link: '/section',
  },
  {
    label: 'ส่วนบังคับบัญชา',
    icon: 'grid',
    link: '/organization',
  },
  {
    label: 'ส่วนบังคับการ',
    icon: 'layers',
    link: '/division',
  },
  {
    label: 'ส่วนกำกับการ',
    icon: 'menu',
    link: '/subdivision',
  },
  {
    label: 'ฝ่ายงาน',
    icon: 'list',
    link: '/department',
  },
  {
    label: 'ศูนย์/สถาบัน',
    icon: 'book',
    link: '/institute',
  },
  {
    label: 'กลุ่มสายงาน',
    icon: 'circle',
    link: '/field-group',
  },
  {
    label: 'สายงาน',
    icon: 'disc',
    link: '/field',
  },
  {
    label: 'จัดการข้อมูลผู้ใช้งาน',
    isTitle: true,
  },
  {
    label: 'ตำแหน่ง',
    icon: 'star',
    link: '/position',
  },
  {
    label: 'ระดับชั้น',
    icon: 'loader',
    link: '/class',
  },
  {
    label: 'ยศ',
    icon: 'award',
    link: '/rank',
  },
  {
    label: 'รายชื่อผู้ใช้งาน',
    icon: 'user',
    link: '/user',
  },
  {
    label: 'รายชื่อผู้ใช้งาน (สำหรับผู้ดูแลระบบ)',
    icon: 'users',
    link: '/users',
  },
  {
    label: 'คำร้องขอใช้ระบบงาน',
    icon: 'shield',
    link: '/request-to-access',
  },
  // {
  //   label: 'จัดการระบบงาน',
  //   isTitle: true,
  // },
  // {
  //   label: 'ระบบงาน',
  //   icon: 'folder',
  //   link: '/application',
  // },
];
